import { graphql } from '../../query/graphql'

const ParentTreeFragmentAllLocales = graphql(/* GraphQL */ `
  fragment ParentTreeFragmentAllLocales on PageRecord @_unmask {
    parent {
      slug
      pageTitle
      _allSlugLocales {
        locale
        value
      }
      parent {
        slug
        pageTitle
        _allSlugLocales {
          locale
          value
        }
        parent {
          slug
          pageTitle
          _allSlugLocales {
            locale
            value
          }
          parent {
            slug
            pageTitle
            _allSlugLocales {
              locale
              value
            }
            parent {
              slug
              pageTitle
              _allSlugLocales {
                locale
                value
              }
            }
          }
        }
      }
    }
  }
`)

export default ParentTreeFragmentAllLocales
